import { render } from "./GroupEditor.vue?vue&type=template&id=0b5f0a56"
import script from "./GroupEditor.vue?vue&type=script&lang=js"
export * from "./GroupEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__